import { observer } from 'mobx-react-lite';
import React, { FC, useCallback, useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

import { IcBackIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconButton, Link } from '@gem/ui-kit';
import { getMascotImageSrc } from '@gem/utils';

import Tasks from 'APP/Tasks';
import { UnauthorizedLayout } from 'APP/components/UnauthorizedLayout/UnauthorizedLayout';
import { RouterLink } from 'APP/router/constants';
import Entities from 'STORE';

import styles from './UntrustedView.styles.m.css';

export const UntrustedView: FC = observer(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const onBack = useCallback(async () => {
    await Tasks.authorization.logout(true);
    navigate(RouterLink.Login, { replace: true });
  }, []);

  useEffect(() => {
    return () => {
      Entities.authStore.setIsUntrusted(false);
    };
  }, []);

  if (!Entities.authStore.isUntrusted) {
    return (
      <Navigate
        to={{
          pathname: RouterLink.Login,
        }}
        replace
      />
    );
  }

  if (Entities.authStore.isAuthenticated && Entities.usersStore.Me?.isUserValid) {
    return (
      <Navigate
        to={{ pathname: RouterLink.Main, search: location.search, hash: '' }}
        replace
      />
    );
  }

  return (
    <UnauthorizedLayout
      mainWrapperClassName={styles.container}
      footer={
        <div className={styles.footer}>
          {t('trusted_device_no_access_contact_support')}
          &nbsp;
          <Link
            color="primary"
            underline={false}
            onClick={(): void => {
              Tasks.app.openSupport();
            }}
          >
            {t('common_contact_support')}
          </Link>
        </div>
      }
    >
      <div className={styles.content}>
        <IconButton
          Icon={IcBackIcon}
          onClick={onBack}
          className={styles.buttonBack}
        />
        <img
          src={getMascotImageSrc('ic-secure-confirm.png')}
          className={styles.logo}
          alt={''}
        />
        <div className={styles.title}>{t('trusted_device_confirm_sign_in_title')}</div>
        <div className={styles.subtitle}>{t('trusted_device_confirm_sign_in_description')}</div>
      </div>
    </UnauthorizedLayout>
  );
});
